<template>
	<div>
		<el-dialog :show-close="false" :visible.sync="$store.state.isForgotShow">
			<div class="loginBox fontPB">
	  			<div class="boxItem">
	  				<div class="title">
	  					<div>{{$t('dialog.forgotTitle')}}</div>
	  					<p class="fontPR">{{$t('dialog.account')}} <span class="fontPM" @click="$store.commit('changeForgotShow',false);">{{$t('dialog.signup')}}</span></p>
	  				</div>
	  				<el-form labelPosition="top" ref="regForm" :model="form" :rules="rules">
					  	<el-form-item prop="email" :error="errs.email">
	  						<div class="formLabel" solt="label">{{$t('dialog.email')}}</div>
						    <el-input width="100px" style="padding-right: 75px;" placeholder="you@example.com" v-model="form.email"></el-input>
						    <el-button style="position: absolute;bottom:0;right: 0;width:70px;" type="primary" @click="getCode()">Get</el-button>
					  	</el-form-item>
					  	<el-form-item prop="verification_code" :error="errs.verification_code">
	  						<div class="formLabel" solt="label">{{ $t('dialog.code') }}</div>
						    <el-input :placeholder="$t('dialog.code')" v-model="form.verification_code"></el-input>
					  	</el-form-item>
					  	<el-form-item prop="password">
	  						<div class="formLabel" solt="label">{{$t('dialog.pass')}}</div>
						    <el-input show-password :placeholder="$t('dialog.char')" v-model="form.password"></el-input>
					  	</el-form-item>
					  	<el-form-item prop="confirmPassword">
	  						<div class="formLabel" solt="label">{{$t('dialog.cpass')}}</div>
						    <el-input show-password :placeholder="$t('dialog.char')" v-model="form.confirmPassword"></el-input>
					  	</el-form-item>
	  				</el-form>
	  				<div class="iconGroup">
	  					<el-button class="reg fontMB" plain @click="setPassWord()">{{$t('dialog.sub')}}</el-button>
	  				</div>
	  			</div>
	 			<div class="boxItem">
	 				<div class="otherTitle">
	 					<div class="line"></div>
	 					<div class="signUp fontMR">{{$t('dialog.signWith')}}</div>
	 					<div class="line"></div>
	 				</div>
	 				<div class="otherIcons fontMB">
	  					<el-button icon="el-icon-google" style="width: 48%;height: 40px;color:#DB4437;background-color: #fff;border-color:#DB4437; " @click="googleLogin();">
	  						<span>{{$t('dialog.google')}}</span>
	  					</el-button>
  						<el-button icon="el-icon-fb" style="width: 48%;height: 40px;color:#3B5998;background-color: #fff;border-color:#3B5998;" plain @click="faceLogin();">
  							<span>{{$t('dialog.face')}}</span>
				    	</el-button>
	  				</div>
	 			</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data () {
		var validateEmail = (rule, value, callback) => {
	        var myreg = /^([a-zA-Z0-9]+[_|\_|\.\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
            if (value === '') {
                callback(new Error(this.$t('dialog.pemail')));
            }else if(!myreg.test(value)){
                callback(new Error(this.$t('dialog.pvemail')));
            } else {
                callback();
            }
	    };
	    var validateCode = (rule, value, callback) => {
	        if (value === '') {
	          	callback(new Error(this.$t('dialog.pcode')));
	        } else {
	          	callback();
	        }
	    };
	    var validatePass = (rule, value, callback) => {
	        if (value === '') {
	          	callback(new Error(this.$t('dialog.ppass')));
	        } else if(value.length<6){
        		callback(new Error(this.$t('dialog.p6pass')));
	        }else{
	        	this.$refs.regForm.validateField('confirmPassword');
	        	callback();
	        }
	    };
	    var validateCP = (rule, value, callback) => {
	        if (value === '') {
          		callback(new Error(this.$t('dialog.pcpass')));
        	} else if (value !== this.form.password) {
          		callback(new Error(this.$t('dialog.ptpass')));
        	} else {
          		callback();
        	}
	    };
		return {
			form:{
				email:'',
				verification_code:'',
				password:'',
				confirmPassword:'',
				verification_key: '',
			},
			rules: {
	          	email: [
	            	{ validator: validateEmail, trigger: 'blur' }
	          	],
	          	verification_code: [
	            	{ validator: validateCode, trigger: 'blur' }
	          	],
	          	password: [
	            	{ validator: validatePass, trigger: 'blur' }
	          	],
	          	confirmPassword: [
	            	{ validator: validateCP, trigger: 'blur' }
	          	],
        	},
        	errs:{
				email:'',
				verification_code:'',
        	},
			checked:false,
		}
	},
	mounted(){

	},
	methods:{
		getCode(){
			if(this.form.email){
				console.log(this.form.email);
				this.$axios({
	                method: 'post',
	                url:'/api/verificationCodes/emails',
	                data:{
	                	email: this.form.email
	                }
	            }).then(res => {
	                console.log(res);
	                this.form.verification_key = res.key;
	            }).catch(error=>{
	            	console.log(error);
	            });
			}else{
				this.$refs.regForm.validateField('email');
			}
		},
		setPassWord(){
	        this.$refs.regForm.validate((valid) => {
        		if (valid) {
        			this.$axios({
		                method: 'post',
		                url:'/api/users/password/forgot',
		                data:this.form
		            }).then(res => {
		                console.log(res);
		                this.$message({
		                	message:res.message,
		                	type: 'success',
                    		duration:1800,
                    		offset:200
		                });
		                this.$refs.regForm.resetFields();
		                this.$store.commit('changeForgotShow',false);
		                this.$store.commit('changeLoginShow',true);
		            }).catch(error=>{
		            	console.log(error);
		            });
	          	} else {
	            	return false;
	          	}
	        });
		},
		googleLogin(){
			this.ga.event('register', 'submit', 'google');
			fbq('track', 'register',{content_name:'google'});
			window.location.href= "https://www.wennoanimal.com/api/google";
		},
		faceLogin(){
			this.ga.event('register', 'submit', 'facebook');
			fbq('track', 'register',{content_name:'facebook'});
   			window.location.href= "https://www.wennoanimal.com/api/facebook";
		},
	}
}
</script>
<style scoped>
	/deep/ .el-dialog{width:70%;}
	/deep/ .el-dialog__header{
		display: none;
	}
	/deep/ .remember .el-checkbox__input.is-checked .el-checkbox__inner,/deep/ .remember .el-checkbox__input.is-indeterminate .el-checkbox__inner{
	    background-color: #FB8E44;
    	border-color: #FB8E44;
	}
	/deep/ .remember .el-checkbox__label{
		font-size: 12px;
	}
	/deep/ .remember .el-checkbox__input.is-checked+.el-checkbox__label{
		color: #FB8E44;
	}
	.loginBox{
		width: 100%;
		min-height:300px;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		color: #000;
	}
	.boxItem{
		width: 45%;
		min-height: 300px;
	}
	.title{
		min-height: 80px;word-break:break-word;
	}
	.title>div{
		font-size: 30px;
		color:#010D3E;
	}
	.title>p{
		line-height: 30px;
		font-size: 16px;
		color:#9595A4;
	}
	.title>p>span:hover{
		cursor: pointer;
	}
	.title>p>span{
		color: #FB8E44;
	}
	/deep/.is-disabled.reg{
		background-color: #C0C4CC;
		color: #fff;
		border-color: #fff;
	}
	/deep/.is-disabled.reg:hover{
		background-color: #C0C4CC;
		color: #fff;
		border-color: #fff;
	}
	.reg,.reg:hover,.reg:active,.reg:focus,.reg:visited{
		width: 100%;
		height: 40px;
		color:#fff;
		border-color: #409EFF;
		background-color: #FB8E44;
	}
	.formLabel{
		height: 30px;
		line-height: 30px;
		color: #000;
		font-size: 16px;
	}

	.iconGroup{
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.otherTitle{
		height: 20px;
		margin-top: 41px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.signUp{
		width: 100px;
		height: 20px;
		text-align: center;
		font-size: 14px;
		color: #D0D0E4;
	}
	.line{
		flex: auto;
		height: 1px;
		background-color: #D0D0E4;
	}
	.otherIcons{
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	/*手机*/
    @media screen and (max-width: 768px){
		/deep/ .el-dialog{width:85%;}
		.loginBox{
			display:block;
		}
		.boxItem{
			width:100%;min-height:auto;
		}
    }
    @media screen and (max-width: 500px){
		/deep/ .el-dialog{width:95%;}
		.title>div{
			font-size: 24px;
		}
    }
    /*平板*/
    @media screen and (min-width: 768px) and (max-width: 992px){
    	/deep/ .el-dialog{width:80%;}
    }
    /*中等屏幕*/
    @media screen and (min-width: 992px) and (max-width: 1200px){
    	/deep/ .el-dialog{width:75%;}
    }
    /*大屏幕*/
    @media screen and (min-width: 1200px){
    	/deep/ .el-dialog{width:70%;max-width:1200px;}
    }
</style>



// WEBPACK FOOTER //
// src/common/ForgotPass.vue